import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { filter, firstValueFrom, take } from 'rxjs';
import { OnboardingStateService } from '@core/services/onboarding-state.service';
import { AuthService } from '../../services/AuthService';

export const onboardingCheckGuard: CanActivateFn = async (_, state) => {
  const authService = inject(AuthService);
  const onboardingState = inject(OnboardingStateService);
  const router = inject(Router);

  if (!authService.authReady()) {
    await firstValueFrom(
      authService.authReady$.pipe(
        filter((ready) => ready),
        take(1)
      )
    );
  }

  if (!authService.isAuthenticated()) {
    return true;
  }

  const completed = await onboardingState.checkOnboardingStatus();

  if (!completed) {
    return router.createUrlTree(['/onboarding'], {
      queryParams: { returnUrl: state.url }
    });
  }

  return true;
};
